/* eslint-disable no-underscore-dangle */
import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const PRICES = 'XXSProductsPrices';

class ProductsPricesStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, PRICES, response.data, onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.prices.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(PRICES)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default ProductsPricesStore;
